export enum LandingSubmitType {
    SIGNUP,
    SINGOFF
}